import { Box, Container, Group, Image, Text } from "@mantine/core";

type PublicLayoutProps = {
  children: React.ReactNode;
};

export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <Box mih="100vh" bg="#f8fafc">
      <Box bg="white" py="md" style={{ borderBottom: "1px solid #e2e8f0" }}>
        <Container size="lg">
          <Group>
            <Image
              src="/assets/images/tap-icon.png"
              alt="Smart Meters"
              width={32}
              height={32}
            />
            <Text fw={700} size="lg" c="#03045e">
              Smart Meters
            </Text>
          </Group>
        </Container>
      </Box>
      <Container size="lg" py="xl">
        {children}
      </Container>
    </Box>
  );
}
